import utils from "../../../utils/utils.js";

export default {

    async initializeUploadSettings(context, settings) {

        if (settings) {
            if (settings.allowedExtensions)
                context.commit('setAllowedExtensions', settings.allowedExtensions);
            if (settings.maxFileSize)
                context.commit('setMaxFileSize', settings.maxFileSize);
            if (settings.maxFileCount)
                context.commit('setMaxFileCount', settings.maxFileCount);
            if (settings.fileSizeType)
                context.commit('setFileSizeType', settings.fileSizeType);

        }
        else {
            context.commit('setAllowedExtensions', ['jpg', 'jpeg', 'png']);
            context.commit('setMaxFileSize', 5 * 1024 * 1024);
            context.commit('setMaxFileCount', 1);
            context.commit('setFileSizeType', ['Bytes', 'KB', 'MB', 'GB', 'TB']);

        }
    },

    async validateFiles(context, files) {

        if (!files || !files.length) {
            context.commit('setError', 'Geçerli dosya bulunamadı.');
            return;
        }

        const maxCount = context.state.maxFileCount;
        if (files.length > maxCount) {
            context.commit('setError', `Sadece ${maxCount} dosya ekleyebilirsiniz!`);
            return;
        }

        const validFiles = [];
        const maxSize = context.state.maxFileSize;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const extension = file.name.split(".").pop().toLowerCase();
            const typeValid = context.state.allowedExtensions.includes(extension);
            const sizeValid = file.size <= context.state.maxFileSize;

            if (!typeValid) {
                context.commit('setError', `Dosya tipi geçerli değil. Hatalı dosya tipi : .${extension} Önerilen dosya tipi : ${context.state.allowedExtensions.join(", ")}`);
                continue;
            }

            if (!sizeValid) {
                const sizes = context.state.fileSizeType;
                const i = parseInt(Math.floor(Math.log(maxSize) / Math.log(1024)));
                var resultbyte = Math.round(maxSize / Math.pow(1024, i)) + " " + sizes[i];

                context.commit("setError", `Dosya boyutu çok büyük: ${file.name}. Sadece ${resultbyte} boyutunda dosya yükleyebilirsiniz!`);
                continue;
            }

            validFiles.push(file);
        }


        if (validFiles.length) {
            context.commit("setSelectedFiles", validFiles);
        } else {
            context.commit("setSelectedFiles", []);
        }
    },

    async clearUploadSettings(context){
        context.commit('setAllowedExtensions', []);
        context.commit('setMaxFileSize', 5 * 1024 * 1024);
        context.commit('setMaxFileCount', 1);
        context.commit('setFileSizeType', []); 
        context.commit('setError', null);

    },
    async postUploadMedia(context, payload) {

        const body = payload.params;
        const endpointMethod = payload.endpointMethod;
        const controller = payload.controller;

        var responseData = await utils.utility.fetch(
            `api/${controller}/${endpointMethod}`,
            "POST",
            null,
            body
        );
        context.commit("setIsSuccessful", responseData.data);
    }

}